import React, { useState } from 'react';
import {
  Alert, Box, Button, IconButton, InputAdornment, Paper, TextField, Typography
} from '@mui/material';
import {
  Inventory2Outlined, LockOutlined, PersonOutline, Visibility, VisibilityOff
} from '@mui/icons-material';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import { useLogowanie } from '../context/KontekstLogowania';

export default function Logowanie() {
  const { uzytkownik, zaloguj } = useLogowanie();
  const navigate = useNavigate();
  const [login, setLogin] = useState('');
  const [haslo, setHaslo] = useState('');
  const [pokazHaslo, setPokazHaslo] = useState(false);
  const [blad, setBlad] = useState('');
  const [logowanie, setLogowanie] = useState(false);

  if (uzytkownik) return <Navigate to="/panel-glowny" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBlad('');
    setLogowanie(true);
    try {
      const wynik = await zaloguj(login.trim(), haslo);
      if (wynik?.wymagana_zmiana_hasla) {
        navigate('/pierwsza-zmiana-hasla', { state:{
          login:wynik.login,
          token_zmiany_hasla:wynik.token_zmiany_hasla,
          message:wynik.message
        } });
        return;
      }
      navigate('/panel-glowny');
    } catch (e) {
      setBlad(e.message || 'Nie udało się zalogować.');
    } finally {
      setLogowanie(false);
    }
  };

  return (
    <Box sx={{ minHeight:'100vh', bgcolor:'#f4f7fb', display:'grid', placeItems:'center', p:{xs:2,md:4} }}>
      <Paper elevation={0} sx={{
        width:'100%', maxWidth:980, minHeight:{md:560}, display:'grid',
        gridTemplateColumns:{xs:'1fr',md:'0.92fr 1.08fr'}, overflow:'hidden', borderRadius:4,
        border:'1px solid #e1e8f2', boxShadow:'0 18px 55px rgba(18,46,84,.10)'
      }}>
        <Box sx={{
          display:{xs:'none',md:'flex'}, flexDirection:'column', justifyContent:'space-between', p:5, color:'#fff',
          background:'linear-gradient(145deg, #173d73 0%, #245fae 58%, #2f80ed 100%)'
        }}>
          <Box>
            <Box sx={{
              width:58,height:58,borderRadius:3,display:'grid',placeItems:'center',
              bgcolor:'rgba(255,255,255,.14)',border:'1px solid rgba(255,255,255,.22)',mb:3
            }}>
              <Inventory2Outlined sx={{fontSize:32}}/>
            </Box>
            <Typography variant="h4" fontWeight={900} sx={{lineHeight:1.15,mb:1.5}}>
              Ewidencja środków trwałych
            </Typography>
            <Typography sx={{color:'rgba(255,255,255,.78)',maxWidth:330,lineHeight:1.65}}>
              Sprzęt, ewidencja i historia zmian w jednym miejscu.
            </Typography>
          </Box>
          <Typography variant="caption" sx={{color:'rgba(255,255,255,.60)'}}>
            System ewidencji środków trwałych
          </Typography>
        </Box>

        <Box component="form" onSubmit={submit} sx={{
          p:{xs:3,sm:5,md:6},display:'flex',flexDirection:'column',justifyContent:'center',bgcolor:'#fff'
        }}>
          <Box sx={{display:{xs:'flex',md:'none'},alignItems:'center',gap:1.2,mb:4}}>
            <Box sx={{width:42,height:42,borderRadius:2.2,display:'grid',placeItems:'center',bgcolor:'#eaf2ff',color:'#2364d8'}}>
              <Inventory2Outlined/>
            </Box>
            <Typography fontWeight={900}>Ewidencja środków trwałych</Typography>
          </Box>

          <Typography variant="h4" fontWeight={900} sx={{color:'#1c2b3a',mb:.7}}>Zaloguj się</Typography>
          <Typography color="text.secondary" sx={{mb:3.5}}>Wprowadź dane swojego konta.</Typography>

          {blad && <Alert severity="error" sx={{mb:2.5,borderRadius:2}}>{blad}</Alert>}

          <TextField
            fullWidth label="Login lub e-mail" value={login} onChange={e=>setLogin(e.target.value)}
            autoComplete="username" required sx={{mb:2}}
            InputProps={{startAdornment:<InputAdornment position="start"><PersonOutline sx={{color:'#7b8794'}}/></InputAdornment>}}
          />

          <TextField
            fullWidth label="Hasło" type={pokazHaslo?'text':'password'} value={haslo}
            onChange={e=>setHaslo(e.target.value)} autoComplete="current-password" required sx={{mb:2.7}}
            InputProps={{
              startAdornment:<InputAdornment position="start"><LockOutlined sx={{color:'#7b8794'}}/></InputAdornment>,
              endAdornment:<InputAdornment position="end">
                <IconButton onClick={()=>setPokazHaslo(v=>!v)} edge="end" aria-label={pokazHaslo?'Ukryj hasło':'Pokaż hasło'}>
                  {pokazHaslo?<VisibilityOff/>:<Visibility/>}
                </IconButton>
              </InputAdornment>
            }}
          />

          <Box sx={{display:'flex',justifyContent:'flex-end',alignItems:'center',mt:-1.2,mb:2.2}}>
            <Typography component={Link} to="/zapomniane-haslo" variant="body2" sx={{color:'#2364d8',textDecoration:'none',fontWeight:750}}>
              Nie pamiętasz hasła?
            </Typography>
          </Box>

          <Button type="submit" variant="contained" fullWidth size="large" disabled={logowanie} sx={{
            minHeight:48,borderRadius:2,textTransform:'none',fontWeight:850,fontSize:15,boxShadow:'none',
            bgcolor:'#2364d8','&:hover':{bgcolor:'#1d56ba',boxShadow:'none'}
          }}>
            {logowanie?'Logowanie...':'Zaloguj'}
          </Button>
        </Box>
      </Paper>
    </Box>
  );
}
